import { bedFor, type Storyboard } from './storyboard';

/**
 * The sound, started inside the tap that asked for it (a phone will not play
 * audio begun anywhere else). The bed goes through a gain node: iOS ignores an
 * audio element's `volume`, and a bed at full volume would bury the narrator.
 */
export interface Player { narration: HTMLAudioElement | null; bed: HTMLAudioElement; ctx: AudioContext | null; stop: () => void }
export function startPlayer(sb: Storyboard): Player {
  const narration = sb.narration ? new Audio(sb.narration.url) : null;
  const bed = new Audio(bedFor(sb.storyId));
  bed.loop = true;
  bed.crossOrigin = 'anonymous';
  let ctx: AudioContext | null = null;
  let gain: GainNode | null = null;
  try {
    const AC = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    ctx = new AC();
    gain = ctx.createGain();
    gain.gain.value = narration ? 0.16 : 0.55;
    ctx.createMediaElementSource(bed).connect(gain).connect(ctx.destination);
  } catch { bed.volume = narration ? 0.16 : 0.55; }
  void bed.play().catch(() => {});
  if (narration) void narration.play().catch(() => {});
  let stopped = false;
  const stop = () => {
    if (stopped) return;
    stopped = true;
    narration?.pause();
    if (gain && ctx) { gain.gain.setTargetAtTime(0, ctx.currentTime, 0.4); setTimeout(() => { bed.pause(); void ctx?.close().catch(() => {}); }, 1400); }
    else bed.pause();
  };
  return { narration, bed, ctx, stop };
}
